import { InputAdornment } from "@mui/material";

/**
 * @name ADDITIONAL_PROPS
 * @constant
 * @object
 * @description Contains list of addtional props for each field type
 */
export const ADDITIONAL_PROPS = {
    coords: {
        InputProps: {
            endAdornment: <InputAdornment position="end">lat, long</InputAdornment>
        }
    },
    date: {
        InputLabelProps: { shrink: true },
        type: 'datetime-local'
    },
    distance: {
        InputProps: {
            endAdornment: <InputAdornment position="end">mi/ft/in</InputAdornment>
        }
    },
    longText: {
        multiline: true,
        inputProps: {
            maxLength: 200
        }
    },
    text: {},
    weight: {
        InputProps: {
            endAdornment: <InputAdornment position="end">lbs/oz</InputAdornment>
        }
    }
}

/**
 * @name MAX_FILE_SIZE
 * @constant
 * @number
 * @description Maximum selectable file size in bytes
 */
export const MAX_FILE_SIZE = 400 * 1024;

/**
 * @name MULTIPART_INPUTS
 * @constant
 * @array
 * @description List of types that should be rendered with a file select
 */
export const MULTIPART_INPUTS  = [ 'image' ];

/**
 * @name TEXT_INPUTS
 * @constant
 * @array
 * @description List of types that should be rendered with a text field
 */
export const TEXT_INPUTS = [ 'longText', 'coords', 'date', 'distance', 'text', 'weight' ];